module.exports = __webpack_public_path__ + "img/frank-frazetta-grappled.5f14e1cf.jpg";